import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToPlainFormat } from '@/utils'

export interface ReturnHistory {
  userId: string
  returnTime: string // 日付タイム
  returnBranchCode: SystemCode
}

export function ReturnHistoryFromJSON(json: any): ReturnHistory {
  return {
    userId: exists(json, 'user_id') ? json.user_id : '',
    returnTime: exists(json, 'return_time')
      ? dateTimeToPlainFormat(json.return_time)
      : '',
    returnBranchCode: exists(json, 'return_branch_code')
      ? SystemCodeFromJSON(json.return_branch_code)
      : defaultSystemCode()
  }
}
